document.addEventListener('DOMContentLoaded', function() {
    Filters.init();
  });

const Filters = {
    selectors: {
      "sortSelect": { selector: ".sort-by", type: "single", scope: "document" },
      "toolbar": { selector: ".toolbar", type: "single", scope: "document" },
      "filtersBtns": {selector: ".filters", type: "all", scope: "document"},
      "numberInputs": { selector: "input[type='number']", type: "all", scope: "document" },
      "allProductCards": { selector: ".product-card", type: "all", scope: "document" },
      "collection": { selector: "#collection-handle", type: "single", scope: "document" },
      "checkboxes": { selector: "input[type='checkbox']", type: "all", scope: "document" },
      "filtersClose": { selector: ".filters-close", type: "single", scope: "document" },
      "filterCategories": { selector: ".sidebar-title", type: "all", scope: "document" }
    },
    init: function() {
      Utility.fetchEls(this.selectors, this);
      this.sizeMapping = {
        'Extra Small': 'XS',
        'Small': 'S',
        'Medium': 'M',
        'Large': 'L',
        'Extra Large': 'XL',
        '2X Large': '2XL',
        '3X Large': '3XL'
      }
      this.sortMap = {
        'alpha': 'title-ascending',
        'alpha-rev': 'title-descending',
        'price': 'price-ascending',
        'price-rev': 'price-descending',
        'date-rev': 'created-descending',
        'date': 'created-ascending',
        'best-selling': 'best-selling',
        'manual': 'manual'
      }

      this.filtersSelected = 0;
      
      if (this.collection) {
        this.collectionHandle = this.collection.dataset.handle;
        this.initFilters();
      }
      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => {
          this.sortProducts(this.sortSelect.value);
        });
      }
      
      const currentUrl = new URL(window.location.href);
      const sortByParam = currentUrl.searchParams.get('sort_by');
      const reverseSortMap = {};
      for (const key in this.sortMap) {
        reverseSortMap[this.sortMap[key]] = key;
      }
      if (sortByParam && reverseSortMap[sortByParam]) {
        this.sortSelect.value = reverseSortMap[sortByParam];
      }

      if (this.filtersBtns) {
        this.filtersBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.toggleFilters(btn);
          });
        });
      }
      
      if (this.filterCategories) {
        this.filterCategories.forEach((category) => {
          category.addEventListener('click', () => {
            this.toggleFilterCategory(category);
          });
        });
      }
      
      if (this.filtersClose) {
        this.filtersClose.addEventListener('click', () => {
          let curBtn;
          this.filtersBtns.forEach((btn) => {
            if (window.getComputedStyle(btn).display === 'flex') {
              curBtn = btn;
            }
          });
          if (curBtn) {
            this.toggleFilters(curBtn);
          }
        });
      }

      if (this.allProductCards) {
        this.allProductCards.forEach((card) => {
            const img = card.querySelector('.product-card-img');
              img.addEventListener('mouseenter', () => {
                const nextImg = img.dataset.nextImg;
                const firstImg = img.dataset.firstImg;
                if (nextImg && firstImg) {
                   img.src = nextImg; 
                }
              });
              img.addEventListener('mouseleave', () => {
                const nextImg = img.dataset.nextImg;
                const firstImg = img.dataset.firstImg;
                if (nextImg && firstImg) {
                   img.src = firstImg; 
                }
              });
        });
      }
    },
    sortProducts: function(sort) {
      const selectedSort = this.sortMap[sort];
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('sort_by', selectedSort);
      window.location.href = currentUrl.toString();
    },
    toggleFilterCategory: function(category) {
      const container = category.closest('.filter-key');
      container.classList.contains('expanded') ? container.classList.remove('expanded') : container.classList.add('expanded');
    },
    getFilters: function() {
        const form = document.querySelector('#filtersForm');
        const { filtersData } = this;
        if (!filtersData) {
            console.error("Failed to load filter configuration");
            return;
        }
    
        let filters = {
            price: { 
                min: form.querySelector('.filter__min').value,
                max: form.querySelector('.filter__max').value
            }
        };
    
        filtersData.filters.forEach(filter => {
            // Convert filter labels to camelCase
            const filterKey = filter.label.toLowerCase()
              .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());
    
            const inputs = form.querySelectorAll(`input[name="${filter.values[0].param_name}"]:checked`);
            filters[filterKey] = Array.from(inputs).map(input => input.value);
        });
    
        return filters;
    },

    normalizeSizes: function(sizes) {
        return sizes.map(size => this.sizeMapping[size] || size);
    },
    
    filterProducts: function(e, filters) {
      e.preventDefault();
      const {filtersBtn} = this;
      const allProducts = document.querySelectorAll('.main-content .product-card');
      
      allProducts.forEach((product, index) => {
          let isVisible = true;
      
          Object.keys(filters).forEach((key) => {
              const filterValues = filters[key];
                  if (key == 'price') {
                      const price = parseFloat(product.dataset.price) / 100;
                      if (price < parseFloat(filters.price.min) || price > parseFloat(filters.price.max)) {
                          isVisible = false;
                      }
                  } else if (key == 'handleLength' && filterValues.length > 0) {
                      const handleLengthFilters = {
                          '5 - 5.49': { min: 5, max: 5.49 },
                          '5.5+': { min: 5.5, max: Infinity },
                          'Under 5': { min: 0, max: 4.99 }
                      };
                      const handleLength = parseFloat(product.dataset.handleLength);
                      let handleLengthMatch = filterValues.some(selectedRange => {
                          const { min, max } = handleLengthFilters[selectedRange];
                          return handleLength >= min && handleLength <= max;
                      });
                      if (!handleLengthMatch) {
                          isVisible = false;
                      }
                  } else if (filterValues.length > 0) {
                      if (!product.dataset[key]) {
                          isVisible = false;
                      } else {
                          let productData = product.dataset[key];
                          try {
                              productData = JSON.parse(productData);
                          } catch (e) {
                              productData = productData.split(',').map(item => item.trim());
                          }
                          if (key === 'size') {
                            productData = this.normalizeSizes(productData);
                          }
                          const hasRequiredData = filterValues.some(value => productData.includes(value));
                          if (!hasRequiredData) {
                              isVisible = false;
                          }
                      }
                  }
              });

          // Set display property based on visibility
          product.style.display = isVisible ? 'flex' : 'none';
      });
  
      if (window.innerWidth < 1201) {
        this.toggleFilters(filtersBtn);
      }
    },
    toggleFilters: function(btn) {
      const filtersContainer = document.querySelector('.filters-container');
      const screen = window.innerWidth > 768 ? '.desktop' : '.mobile';
      const filtersText = btn.querySelector(`.filters-text${screen}`);
      const filters = document.querySelector('.filter-sidebar');
      if (filtersText.textContent.includes('Show')) {
        this.showFilters(filtersText, filters, filtersContainer);
      } else {
        this.hideFilters(filtersText, filters, filtersContainer);
      }
    },
    hideFilters: function(filtersText, filters, container) {
      filtersText.textContent = 'Show Filters';
      filters.style.display = 'none';
      if (container) {
        container.style.display = 'none';
      }
    },
    showFilters: function(filtersText, filters, container) {
      filtersText.textContent = 'Hide Filters';
      filters.style.display = 'block';
      if (container) {
        container.style.display = 'block';
      }
    },
    hasActiveFilters: function(filters) {
      return Object.values(filters).some(value => {
        if (Array.isArray(value)) {
          return value.length > 0; // Check if any array filters are not empty
        }
        if (typeof value === 'object' && value !== null) {
          // Check if price filter has valid min and max values
          return parseFloat(value.min) > 0 || parseFloat(value.max) < 270;
        }
        return false; // Default for unhandled types
      });
    },
    initFilters: async function() {
      this.checkboxes.forEach(checkbox => {
          if (checkbox.name !== 'category-filter') {
              checkbox.addEventListener('change', (event) => {
                  console.log('event.target', event.target);
                  console.log('getting filters');
                  const filters = this.getFilters();
                  
                  // Check if any filters are active
                  const filtersActive = this.hasActiveFilters(filters);
                  console.log('Filters active:', filtersActive);

                  // Hide or show promo graphics based on filter state
                  const promoGraphicCards = document.querySelectorAll('.promo-graphic-card');
                  promoGraphicCards.forEach(card => {
                      card.style.display = filtersActive ? 'none' : 'block';
                  });

                  if (this.collectionHandle === 'pickleball-paddles' && this.collection.dataset.category === 'false') {
                      AllPaddlesPage.seeAllCategory('pickleball-paddles', true);
                  } else if (this.collectionHandle === 'holiday-shop' && this.collection.dataset.category === 'false') {
                      console.log('filters', filters);
                      if (!filtersActive) {
                          BlackFriday24.showAllDeals();
                      } else {
                          BlackFriday24.seeAllCategory('holiday-shop', true);
                      }
                  }
                  
                  this.filterProducts(event, filters);
              });
          }
      });
      
      this.numberInputs.forEach((input) => {
          let typingTimer;
          const typingDelay = 1000;
          input.addEventListener('keyup', (event) => {
              clearTimeout(typingTimer);
              typingTimer = setTimeout(() => {
                  const filters = this.getFilters();
                  this.filterProducts(event, filters);
              }, typingDelay);
          });
      });
      this.fetchFilters();
    },
    fetchFilters: async function() {
      try {
        const response = await fetch(`/collections/${this.collectionHandle}?view=filters`);
        if (!response.ok) throw new Error('Network response was not ok');
        const filtersData = await response.json();
        this.filtersData = filtersData;
      } catch (error) {
        console.error('Final attempt failed:', error);
        return null;
      }
    }
  };
